import { StatusBar, Style } from '@capacitor/status-bar';
import { isApp } from './env';
import { installLinkHandler } from './links';

/** Значки статус-бара под тему: data-theme, а без него — тема системы. */
export function statusBarStyle(): Style {
  const t = document.documentElement.getAttribute('data-theme');
  const dark = t ? t === 'dark' : window.matchMedia?.('(prefers-color-scheme: dark)').matches;
  return dark ? Style.Dark : Style.Light;
}

/** Всё, что сайт включает только внутри приложения для iPhone. */
export function initApp(): void {
  if (!isApp()) return;
  installLinkHandler();
  const sync = () => void StatusBar.setStyle({ style: statusBarStyle() }).catch(() => {});
  sync();
  new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
  window.matchMedia?.('(prefers-color-scheme: dark)').addEventListener('change', sync);
}
